/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Submit_ButtonInputs */

const en_embed_captions_submit_button = /** @type {(inputs: Embed_Captions_Submit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit Job`)
};

const fr_embed_captions_submit_button = /** @type {(inputs: Embed_Captions_Submit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumettre la tache`)
};

const de_embed_captions_submit_button = /** @type {(inputs: Embed_Captions_Submit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job einreichen`)
};

const it_embed_captions_submit_button = /** @type {(inputs: Embed_Captions_Submit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia lavoro`)
};

const ru_embed_captions_submit_button = /** @type {(inputs: Embed_Captions_Submit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить вакансию`)
};

const es_embed_captions_submit_button = /** @type {(inputs: Embed_Captions_Submit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar trabajo`)
};

const zh_cn2_embed_captions_submit_button = /** @type {(inputs: Embed_Captions_Submit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交职位`)
};

const ja_embed_captions_submit_button = /** @type {(inputs: Embed_Captions_Submit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジョブを送信`)
};

const hi_embed_captions_submit_button = /** @type {(inputs: Embed_Captions_Submit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नौकरी जमा करें`)
};

const pt_pt2_embed_captions_submit_button = /** @type {(inputs: Embed_Captions_Submit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar vaga`)
};

/**
* | output |
* | --- |
* | "Submit Job" |
*
* @param {Embed_Captions_Submit_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_submit_button = /** @type {((inputs?: Embed_Captions_Submit_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Submit_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_submit_button(inputs)
	if (locale === "de") return de_embed_captions_submit_button(inputs)
	if (locale === "it") return it_embed_captions_submit_button(inputs)
	if (locale === "ru") return ru_embed_captions_submit_button(inputs)
	if (locale === "es") return es_embed_captions_submit_button(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_submit_button(inputs)
	if (locale === "ja") return ja_embed_captions_submit_button(inputs)
	if (locale === "hi") return hi_embed_captions_submit_button(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_submit_button(inputs)
	return en_embed_captions_submit_button(inputs)
});